import React from 'react';

const columnCenter = (): React.CSSProperties => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  };
};

export default columnCenter;
